export const renderGridHeight = (accountList, gridHeight) => {
	if (accountList?.length <= 10) {
		return 'auto';
	}
	if (accountList?.length) {
		return gridHeight;
	}
	return 300;
};
